import React from 'react';

/**
 * Founder of AUDIVUE Badge — reserved for AUDIVUE's founder(s).
 * Distinct from the numbered Founding Creator badge.
 *
 * Visual: dark backdrop with a rotating conic-gradient ring (cyan →
 * magenta → orange → cyan), a crown icon, and "Founder of AUDIVUE" wordmark.
 *
 * Props:
 *   - size: 'sm' (video cards) | 'md' (profile header). Default 'md'.
 *   - className: extra Tailwind
 */
export const FounderBadge = ({ size = 'md', className = '' }) => {
  const isMd = size === 'md';
  return (
    <span
      className={`relative inline-flex items-center gap-1.5 rounded-full font-bold tracking-wide overflow-hidden ${
        isMd ? 'px-3.5 py-1.5 text-xs' : 'px-2 py-0.5 text-[10px]'
      } ${className}`}
      style={{ background: '#0a0a0a' }}
      title="Founder of AUDIVUE"
      data-testid="founder-badge"
    >
      {/* Rotating conic-gradient border ring */}
      <span
        aria-hidden
        className="absolute -inset-[1px] rounded-full pointer-events-none"
        style={{
          background:
            'conic-gradient(from 0deg, #22d3ee, #a78bfa, #ec4899, #f59e0b, #22d3ee)',
          animation: 'founder-spin 4s linear infinite',
        }}
      />
      {/* Inner dark fill that masks the center of the ring */}
      <span
        aria-hidden
        className="absolute inset-[1.5px] rounded-full pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at top, rgba(168,139,250,0.15), rgba(10,10,10,1) 70%)',
        }}
      />
      {/* Crown icon */}
      <svg
        width={isMd ? '14' : '11'}
        height={isMd ? '14' : '11'}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="relative"
        style={{
          color: '#fbbf24',
          filter: 'drop-shadow(0 0 4px rgba(251, 191, 36, 0.7))',
        }}
        aria-hidden
      >
        <path d="M2 4l3 12h14l3-12-6 7-4-7-4 7-6-7zM5 20h14" />
      </svg>
      <span
        className="relative bg-clip-text text-transparent"
        style={{
          backgroundImage:
            'linear-gradient(90deg, #22d3ee 0%, #f0abfc 50%, #fbbf24 100%)',
        }}
      >
        {isMd ? 'Founder of AUDIVUE' : 'Founder'}
      </span>
    </span>
  );
};

export default FounderBadge;
